import { useStore } from '../store.js';

const SECTIONS = [
  {
    title: 'Business',
    fields: [
      ['business_name', 'Business name'],
      ['dba', 'DBA'],
      ['federal_tax_id', 'Federal Tax ID'],
      ['business_start_date', 'Start date'],
      ['industry', 'Industry'],
      ['entity_type', 'Entity type'],
      ['business_address_street', 'Street'],
      ['business_address_line2', 'Suite'],
      ['business_city', 'City'],
      ['business_state', 'State'],
      ['business_zip', 'ZIP'],
    ],
  },
  {
    title: 'Funding',
    fields: [
      ['gross_monthly_sales', 'Gross monthly sales'],
      ['monthly_cc_volume', 'Monthly CC volume'],
      ['avg_bank_balance', 'Avg bank balance'],
      ['has_liens', 'Liens?'],
      ['previous_mca', 'Previous MCA?'],
    ],
  },
];

export function Review({ onNext, onBack }) {
  const { data, owners, documents } = useStore((s) => ({
    data: s.data, owners: s.owners, documents: s.documents,
  }));

  return (
    <div className="space-y-6">
      <header>
        <h2 className="text-xl font-semibold text-brand-900">Review</h2>
        <p className="text-sm text-slate-500">Double-check everything before signing. You can still go back to make changes.</p>
      </header>

      {SECTIONS.map((s) => (
        <section key={s.title} className="card p-4">
          <h3 className="font-medium text-slate-800 mb-3">{s.title}</h3>
          <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
            {s.fields.map(([k, label]) => (
              <div key={k} className="flex justify-between gap-4 border-b border-slate-100 py-1">
                <dt className="text-slate-500">{label}</dt>
                <dd className="text-slate-900 text-right truncate">{data[k] || <span className="text-slate-400">—</span>}</dd>
              </div>
            ))}
          </dl>
        </section>
      ))}

      <section className="card p-4">
        <h3 className="font-medium text-slate-800 mb-3">Owners ({owners.length})</h3>
        <ul className="divide-y divide-slate-100 text-sm">
          {owners.map((o) => (
            <li key={o.id} className="py-2 flex justify-between">
              <span>{o.first_name} {o.last_name}</span>
              <span className="text-slate-500">{o.ownership_pct}%</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="card p-4">
        <h3 className="font-medium text-slate-800 mb-3">Documents ({documents.length})</h3>
        <ul className="divide-y divide-slate-100 text-sm">
          {documents.map((d) => (
            <li key={d.id} className="py-2 flex justify-between">
              <span>{d.file_name}</span>
              <span className="text-slate-500">{d.category}</span>
            </li>
          ))}
          {documents.length === 0 && <li className="text-slate-400 py-2">No documents uploaded</li>}
        </ul>
      </section>

      <div className="flex justify-between">
        <button className="btn-ghost" onClick={onBack}>Back</button>
        <button className="btn-primary" onClick={onNext}>Continue to sign</button>
      </div>
    </div>
  );
}
